<template>
	<div ref="popupContainer">
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir valider la supression de l'achat ?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-popup
			:active.sync="showInvoiceDatePopup"
			:title="`Saisissez la date de facturation pour ${
				currentPurchase && currentPurchase.society_name
					? currentPurchase.society_name
					: ''
			}.`"
			style="z-index: 53001"
		>
			<div v-if="currentPurchase">
				<div class="vx-row">
					<div class="vx-col">
						{{ currentPurchase.society_name }}
					</div>
					<div class="vx-col">Contrat N°{{ currentPurchase.contract_id }}</div>
					<div class="vx-col">
						{{ getServiceIdToName(currentPurchase.service_id) }}
					</div>
					<div class="vx-col">
						{{ getProviderIdToName(currentPurchase.users_id) }}
					</div>
					<div class="vx-col">
						{{
							currentPurchase.recurrence_date
								? convertInternationalNumberToFrenchCurrency(
										currentPurchase.recurrence_price
								  )
								: convertInternationalNumberToFrenchCurrency(
										currentPurchase.price
								  )
						}}
					</div>
				</div>
				<div class="vx-row mt-4">
					<div class="vx-col w-1/2">
						<vx-input-group class="mb-6">
							<flat-pickr
								class="w-full"
								v-model="currentPurchaseInvoiceDateTemp"
								placeholder="Date de facturation"
								:config="configDatePicker"
							/>
							<template slot="append">
								<div class="append-text btn-addon">
									<vs-button color="primary" @click="resetInvoiceDate()"
										>X</vs-button
									>
								</div>
							</template>
						</vx-input-group>
					</div>
					<div class="vx-col w-1/2">
						<vs-button color="primary" class="w-full" @click="saveInvoiceDate()"
							>Enregistrer</vs-button
						>
					</div>
				</div>
			</div>
			<div v-if="!editFacturation && !currentPurchase">
				<div class="vx-row">
					<vs-table :data="currentPurchases">
						<template slot-scope="{ data }">
							<vs-tr :key="index" v-for="(currentPurchase, index) in data">
								<vs-td class="text-center">{{
									currentPurchase.society_name
								}}</vs-td>
								<vs-td class="text-center"
									>Contrat N°{{ currentPurchase.contract_id }}</vs-td
								>
								<vs-td class="text-center">{{
									getServiceIdToName(currentPurchase.service_id)
								}}</vs-td>
								<vs-td class="text-center">{{
									getProviderIdToName(currentPurchase.users_id)
								}}</vs-td>
								<vs-td class="text-center">{{
									currentPurchase.recurrence_date
										? convertInternationalNumberToFrenchCurrency(
												currentPurchase.recurrence_price
										  )
										: convertInternationalNumberToFrenchCurrency(
												currentPurchase.price
										  )
								}}</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>
				<div class="vx-row mt-4">
					<div class="vx-col w-1/2">
						<vx-input-group class="mb-6">
							<flat-pickr
								class="w-full"
								v-model="currentPurchaseInvoiceDateTemp"
								placeholder="Date de facturation"
								:config="configDatePicker"
							/>
							<template slot="append">
								<div class="append-text btn-addon">
									<vs-button color="primary" @click="resetInvoiceDate()"
										>X</vs-button
									>
								</div>
							</template>
						</vx-input-group>
					</div>
					<div class="vx-col w-1/2">
						<vs-button
							color="primary"
							class="w-full"
							@click="saveInvoiceDateForAll()"
							>Enregistrer</vs-button
						>
					</div>
				</div>
			</div>
		</vs-popup>
		<div>
			TOTAL PRIX D'ACHAT　: <b>{{ getTotal("achat") }}</b>
		</div>
		<div>
			TOTAL PRIX DE VENTE : <b>{{ getTotal("sell") }}</b>
		</div>
		<vs-table
			:data="purchases"
			pagination
			:max-items="15"
			stripe
			:max-height="tableHeight + 'px'"
			id="purchase-table"
			noDataText="Pas de commande"
		>
			<template slot="thead">
				<vs-th v-if="editFacturation" class="th-sticky text-center">
					<label class="form-checkbox">
						<input
							type="checkbox"
							style="margin: 0 5px 0 5px"
							v-model="selectAll"
							@click="select"
						/>
					</label>
				</vs-th>
				<vs-th class="th-sticky text-center" sort-key="user_name"
					><vs-spacer /><span>Consultant</span><vs-spacer
				/></vs-th>
				<vs-th
					class="th-sticky text-center"
					sort-key="society_name"
					v-if="!readOnly"
					><vs-spacer /><span>Société</span><vs-spacer
				/></vs-th>
				<vs-th
					class="th-sticky text-center"
					sort-key="contract_id"
					v-if="!readOnly"
					><vs-spacer /><span>Numéro de contrat</span><vs-spacer
				/></vs-th>
				<vs-th class="th-sticky text-center" sort-key="service_name"
					><vs-spacer /><span>Service</span><vs-spacer
				/></vs-th>
				<vs-th class="th-sticky text-center" sort-key="provider_name"
					><vs-spacer /><span>Prestataire</span><vs-spacer
				/></vs-th>
				<vs-th class="th-sticky text-center" sort-key="price"
					><vs-spacer /><span>Prix Achat (HT)</span></vs-th
				>
				<vs-th class="th-sticky text-center" sort-key="sell_price"
					><vs-spacer /><span>Prix de Vente (HT)</span></vs-th
				>
				<vs-th class="th-sticky text-center" sort-key="input_date"
					><vs-spacer /><span>Date de saisie</span><vs-spacer
				/></vs-th>
				<vs-th class="th-sticky text-center" sort-key="recurrence"
					><vs-spacer /><span>Récurrence</span><vs-spacer
				/></vs-th>
				<!-- <vs-th class="text-center">Est un achat récurrent ?</vs-th> -->
				<vs-th class="th-sticky text-center" sort-key="is_billable"
					><vs-spacer /><span>Facturable</span><vs-spacer
				/></vs-th>

				<vs-th class="th-sticky text-center" sort-key="period_date"
					><vs-spacer /><span>Période</span><vs-spacer
				/></vs-th>
				<vs-th class="th-sticky text-center" sort-key="commentary"
					><vs-spacer /><span>Commentaire</span><vs-spacer
				/></vs-th>
				<vs-th
					v-if="$acl.check('financeadmin') && !readOnly"
					class="th-sticky text-center"
					sort-key="invoice_date"
					><vs-spacer /><span>Rapprochement facture</span><vs-spacer
				/></vs-th>
				<vs-th class="th-sticky" v-if="!readOnly"></vs-th>
				<vs-th class="th-sticky" v-if="!readOnly"></vs-th>
				<vs-th
					class="th-sticky"
					v-if="$acl.check('financesadmin') && !readOnly"
				></vs-th>
			</template>
			<template slot-scope="{ data }">
				<vs-tr :key="index" v-for="(purchase, index) in data">
					<vs-td v-if="editFacturation" class="text-center">
						<label class="form-checkbox">
							<input type="checkbox" :value="purchase.id" v-model="selected" />
						</label>
					</vs-td>
					<vs-td :data="purchase.user_id" class="text-center pdl0">
						<span class="hvr-underline hvr-underline-out">
							<vx-tooltip
								:text="`${purchase.user_firstname} ${purchase.user_lastname}`"
								position="top"
								style="text-align: center"
							>
								<vs-avatar
									style="border: 1px solid gray"
									:text="`${purchase.user_firstname} ${purchase.user_lastname}`"
									:src="getCollaboratorAvatar(purchase.user_id)"
								/>
							</vx-tooltip>
						</span>
					</vs-td>
					<vs-td
						:data="purchase.society_name"
						class="text-center pdl0"
						v-if="!readOnly"
						><span
							@click="displaySocietyPopup(purchase.society_name)"
							class="hvr-underline hvr-underline-out"
							>{{ purchase.society_name }}</span
						></vs-td
					>
					<vs-td
						:data="purchase.contract_id"
						class="text-center pdl0"
						v-if="!readOnly"
						><span
							@click="displayContractPopup(purchase.contract_id)"
							class="hvr-underline hvr-underline-out"
							>{{ purchase.contract_id }}</span
						></vs-td
					>
					<vs-td :data="purchase.service_name" class="text-center pdl0">{{
						getServiceIdToName(purchase.service_id)
					}}</vs-td>
					<vs-td :data="purchase.provider_name" class="text-center pdl0">
						{{ getProviderIdToName(purchase.users_id) }}</vs-td
					>
					<vs-td :data="purchase.price" class="text-right pdl0">
						{{
							purchase.recurrence_date
								? convertInternationalNumberToFrenchCurrency(
										purchase.recurrence_price
								  )
								: convertInternationalNumberToFrenchCurrency(purchase.price)
						}}</vs-td
					>
					<vs-td :data="purchase.sell_price" class="text-right pdl0">
						{{
							convertInternationalNumberToFrenchCurrency(purchase.sell_price)
						}}</vs-td
					>
					<vs-td :data="purchase.input_date" class="text-center pdl0">
						{{
							purchase.recurrence_date
								? getDateToFrenchFormat(formatDate(purchase.recurrence_date))
								: getDateToFrenchFormat(formatDate(purchase.input_date))
						}}</vs-td
					>
					<vs-td :data="purchase.recurrence" class="text-center pdl0">
						{{ getPurchaseFrequency(purchase.recurrence) }}</vs-td
					>
					<!-- <vs-td :data="purchase.recurrence_date" class="text-center"> {{ purchase.recurrence_date ? "Oui" : "Non" }}</vs-td> -->
					<vs-td :data="purchase.is_billable" class="text-center pdl0">
						{{ getUserDashboardAccess(purchase.is_billable) }}</vs-td
					>

					<vs-td :data="purchase.period_date" class="text-center pdl0">
						{{
							purchase.period_date
								? getMonthName(new Date(purchase.period_date)).replace(
										/^\S/,
										(s) => s.toUpperCase()
								  ) +
								  " " +
								  purchase.period_date.substr(0, 4)
								: ""
						}}</vs-td
					>
					<vs-td :data="purchase.commentary" class="text-center pdl0">
						{{ purchase.commentary }}</vs-td
					>
					<vs-td
						v-if="$acl.check('financeadmin') && !readOnly"
						:data="purchase.commentary"
						class="text-center pdl0"
					>
						<vx-tooltip
							v-if="purchase.invoice_date"
							:text="formatInputDate(purchase.invoice_date)"
							><vs-button
								class="material-icons myBtnPrimary"
								@click="displayInvoiceDatePopup(purchase)"
								>fact_check</vs-button
							></vx-tooltip
						>
						<vs-button
							v-else
							class="material-icons myBtn"
							border
							style="color: orange"
							@click="displayInvoiceDatePopup(purchase)"
							>preview</vs-button
						>
					</vs-td>
					<vs-td v-if="!readOnly">
						<vx-tooltip text="Dupliquer l'achat" position="top">
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-copy"
								@click="renewPurchase(purchase.id)"
							></vs-button>
						</vx-tooltip>
					</vs-td>
					<vs-td v-if="!readOnly">
						<vx-tooltip text="Modifier" position="top">
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-edit-2"
								@click="updatePurchase(purchase)"
							></vs-button>
						</vx-tooltip>
					</vs-td>
					<vs-td v-if="$acl.check('financesadmin') && !readOnly">
						<vx-tooltip text="Effacer" position="top">
							<vs-button
								size="large"
								color="danger"
								type="flat"
								icon-pack="feather"
								icon="icon-trash-2"
								@click="displayValidationPopup(purchase)"
							></vs-button>
						</vx-tooltip>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import Vue from "vue";
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import Purchase from "@/entities/Purchase";
import ValidationPopup from "@/components/popups/ValidationPopup";
import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
	name: "PurchasesTable",
	props: {
		purchases: Array,
		loading: Boolean,
		editFacturation: Boolean,
		readOnly: {
			type: Boolean,
			default: false,
		},
		// services: Array,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	components: {
		flatPickr,
		VxTooltip,
	},
	data() {
		return {
			apiErrorMsg: null, // catching api error message
			showValidationPopup: false,
			showInvoiceDatePopup: false,
			currentPurchase: null,
			currentPurchases: [],
			currentPurchaseInvoiceDateTemp: null,
			purchaseToDelete: null,
			basicImgUrl: "task_default.png",
			societyImageList: [],
			configDatePicker: {
				dateFormat: "j/n/Y",
			},
			selected: [],
			selectAll: false,
		};
	},
	created() {
		this.getAllSocieties();
		this.getAllProviders();
		this.getAllServices();
		this.getAllUsers();
	},
	updated() {
		this.$emit("stop-loader");
		let style = document.createElement("link");
		style.rel = "stylesheet";
		style.href = "https://fonts.googleapis.com/icon?family=Material+Icons";
		document.head.appendChild(style);
	},
	mounted() {
		store.dispatch(
			"updateTableHeight",
			this.windowHeigth -
				this.horizentalNavBarHeight -
				this.filterCardHeight -
				0.32 * this.windowHeigth
		);
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				store.dispatch(
					"updateTableHeight",
					this.windowHeigth -
						this.horizentalNavBarHeight -
						this.filterCardHeight -
						0.32 * this.windowHeigth
				);
			});
		});
	},
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		isFilterDown: () => {
			return store.state.isFilterDown;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		tableHeight: () => {
			return store.state.tableHeight;
		},
		societies: () => {
			return store.state.societies;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		users: () => {
			return store.state.users;
		},
	},
	watch: {
		isFilterDown: function () {
			store.dispatch(
				"updateFilterCardHeight",
				document.getElementById("fliterCard").clientHeight
			);
			store.dispatch(
				"updateTableHeight",
				this.windowHeigth -
					this.horizentalNavBarHeight -
					this.filterCardHeight -
					0.32 * this.windowHeigth
			);
		},
		editFacturation: function (data) {
			if (!data && this.selected.length > 0) {
				this.currentPurchases = this.purchases.filter((purchase) => {
					return this.selected.indexOf(purchase.id) != -1;
				});
				this.showInvoiceDatePopup = true;
			} else {
				this.selected = [];
				this.selectAll = false;
			}
		},
		showInvoiceDatePopup: function (data) {
			if (!data) {
				this.selected = [];
				this.selectAll = false;
				this.currentPurchase = false;
			}
		},
	},

	methods: {
		displayInvoiceDatePopup(purchase) {
			this.currentPurchase = purchase;
			this.currentPurchaseInvoiceDateTemp = purchase.invoice_date
				? this.formatInputDate(purchase.invoice_date)
				: null;
			this.showInvoiceDatePopup = true;
		},

		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		/**
		 * Fetch society by id
		 * @param {Number} societyId - The society id
		 */
		getSocietyById(societyId) {
			return this.societies.find((society) => society.id == societyId);
		},

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		getServiceIdToName(service_id) {
			let service_name = "";
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined && service.name != undefined) {
				service_name = service.name;
			}
			return service_name;
		},

		getSocietyIdToName(society_id) {
			let society_name = "";
			let society = this.societies.find((society) => society.id == society_id);
			if (society != undefined && society.name != undefined) {
				society_name = society.name;
			}
			return society_name;
		},

		getProviderIdToName(provider_id) {
			let provider_name = "";
			let provider = this.providers.find(
				(provider) => provider.id == provider_id
			);
			if (provider != undefined && provider.society != undefined) {
				provider_name = provider.society;
			}
			return provider_name;
		},

		getUserName(user_id) {
			let foundUserIndex = this.users.findIndex((row) => row.id == user_id);
			if (foundUserIndex >= 0)
				return `${this.users[foundUserIndex].firstname} ${this.users[foundUserIndex].lastname}`;
			else return "";
		},

		formatDate(date_input) {
			if (date_input && date_input.length > 10) {
				return date_input.substring(0, 10);
			} else {
				return date_input;
			}
		},
		formatInputDate(input_date) {
			let formatedDate = input_date;
			if (input_date && input_date.length > 10)
				formatedDate = input_date.substring(0, 10);
			if (formatedDate.split(" ").length > 0)
				formatedDate = formatedDate.split(" ")[0];
			if (formatedDate.split("-").length > 0)
				formatedDate = formatedDate.split("-").reverse().join("/");
			return formatedDate;
		},
		getAllServices() {
			store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */
		getAllSocieties() {
			store.dispatch("getAllSocieties");
		},
		getAllProviders() {
			store.dispatch("getAllProviders");
		},
		getAllUsers() {
			store.dispatch("getAllUsers");
		},
		getTotal(type) {
			if (this.purchases.length > 0) {
				let price = 0;
				if (type == "achat") {
					let totalPrice = this.purchases.reduce(
						(acc, item) => acc + (item.price || 0),
						0
					);
					return this.convertInternationalNumberToFrenchCurrency(totalPrice);
				} else {
					let totalPrice = this.purchases.reduce(
						(acc, item) => {
							// Use sell_price directly without checking is_billable for total calculation
							// This ensures the total shows all sell prices in the filtered list
							return acc + (item.sell_price || 0);
						},
						0
					);
					return this.convertInternationalNumberToFrenchCurrency(totalPrice);
				}
			}
			return this.convertInternationalNumberToFrenchCurrency(0);
		},

		deletePurchase(purchase) {
			let purchaseToDelete = new Purchase(purchase);
			//console.log(purchase);
			if (purchaseToDelete.recurrence_id) {
				purchaseToDelete.deleterc(
					purchaseToDelete.recurrence_id,
					(err, res) => {
						if (err)
							if (res) {
								//console.log(err);
								this.$emit("delete-line", purchase);
							}
					}
				);
			} else {
				purchaseToDelete.delete(purchaseToDelete.id, (err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							this.$emit("delete-line", purchase);
						}
				});
			}
			this.$forceUpdate();
		},

		displayValidationPopup(purchase) {
			this.purchaseToDelete = purchase;
			this.showValidationPopup = true;
		},

		accept() {
			this.deletePurchase(this.purchaseToDelete);
			this.showValidationPopup = false;
		},

		decline() {
			this.purchaseToDelete = null;
			this.showValidationPopup = false;
		},

		resetInvoiceDate() {
			this.currentPurchaseInvoiceDateTemp = null;
		},

		async saveInvoiceDate() {
			try {
				await Purchase.updatePurchaseInvoiceDate(
					this.currentPurchase.id,
					this.currentPurchaseInvoiceDateTemp
				);
				this.currentPurchase.invoice_date = this.currentPurchaseInvoiceDateTemp
					? this.currentPurchaseInvoiceDateTemp.split("/").reverse().join("-") +
					  " 02:00:00"
					: null;
				this.currentPurchase = null;
				this.currentPurchaseInvoiceDateTemp = null;
				this.$vs.notify({
					title: "Succès",
					text: "Date de facturation modifée avec succès.",
				});
				this.showInvoiceDatePopup = false;
			} catch (e) {
				this.currentPurchase.invoice_date = this.currentPurchase.invoice_date
					? this.currentPurchase.invoice_date
					: null;
				//console.log(e);
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir la date correctement.",
				});
				this.showInvoiceDatePopup = false;
			}
		},

		async saveInvoiceDateForAll() {
			try {
				await Purchase.updatePurchaseInvoiceDateForAll(
					this.selected,
					this.currentPurchaseInvoiceDateTemp
				);
				for (let i = 0; i < this.currentPurchases.length; i++) {
					this.currentPurchases[i].invoice_date = this
						.currentPurchaseInvoiceDateTemp
						? this.currentPurchaseInvoiceDateTemp
								.split("/")
								.reverse()
								.join("-") + " 02:00:00"
						: null;
				}
				this.currentPurchases = [];
				this.currentPurchaseInvoiceDateTemp = null;
				this.$vs.notify({
					title: "Succès",
					text: "Date de facturation modifée avec succès.",
				});
				this.showInvoiceDatePopup = false;
			} catch (e) {
				//console.log(e);
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir la date correctement.",
				});
				return;
			}
		},

		select() {
			this.selected = [];
			if (!this.selectAll) {
				for (let i in this.purchases) {
					this.selected.push(this.purchases[i].id);
				}
			}
		},

		updatePurchase(purchase) {
			if (purchase.recurrence_id) {
				// Create a container div if it doesn't exist
				if (!this.$refs.popupContainer) {
					console.error("popupContainer ref not found");
					return;
				}

				let propsData = {
					propsData: {
						objToRedirect: purchase,
						title:
							"Voulez-vous modifier l'achat original ou l'achat récurrent ?",
						optionOneText: "L'achat original",
						optionTwoText: "L'achat récurrent",
						isActive: true,
					},
				};

				let ComponentClass = Vue.extend(ValidationPopup);
				let validationPopup = new ComponentClass(propsData);
				validationPopup.$mount();

				validationPopup.$on("option-one", (purchase) => {
					this.updateMainPurchase(purchase);
					// Clean up the popup
					validationPopup.$destroy();
				});

				validationPopup.$on("option-two", (purchase) => {
					this.updateRecurringPurchase(purchase);
					// Clean up the popup
					validationPopup.$destroy();
				});

				this.$refs.popupContainer.appendChild(validationPopup.$el);
			} else {
				this.updateMainPurchase(purchase);
			}
		},

		displaySocietyImage(societyId) {
			let foundImage = this.societyImageList.find(
				(society) => society.id == societyId
			);
			if (foundImage) return foundImage.image;
			else return this.basicImgUrl;
		},

		displaySocietyPopup(society) {
			//console.log("displaySocietyPopup", society);
			society.image = this.displaySocietyImage(society.id);
			this.$emit("show-society-popup", society);
		},
		displayContractPopup(contract) {
			//console.log("displayContractPopup", contract);
			this.$emit("show-contract-popup", contract);
		},

		updateMainPurchase(purchase) {
			//console.log("modify-purchase");
			this.$emit("modify-purchase", purchase);
		},

		updateRecurringPurchase(purchase) {
			//console.log("modify-recurring");
			this.$emit("modify-recurring", purchase);
		},

		renewPurchase(purchaseId) {
			this.$emit("renew-purchase", purchaseId);
		},
	},
};
</script>

<style>
.screen_size > div.con-tablex.vs-table--content {
	overflow: auto !important;
}

.hvr-underline-out {
	color: black;
}
.hvr-underline:hover {
	color: aqua;
	text-decoration: underline;
	cursor: pointer;
}
.center {
	justify-content: center;
}
.myBtn {
	background-color: transparent !important;
}
.myBtn:hover {
	box-shadow: none !important;
	background-color: orange !important;
	color: white !important;
}
.myBtnPrimary {
	color: rgba(var(--vs-primary), 1) !important;
	background-color: transparent !important;
}
.myBtnPrimary:hover {
	box-shadow: none !important;
	background-color: rgba(var(--vs-primary), 1) !important;
	color: white !important;
}
#purchase-table > .con-tablex.vs-table--content {
	overflow: auto;
}
</style>
